const isExternalLink = (url: string | null | undefined): boolean => {
  if (!url) {
    return false;
  }
  if (url.startsWith('#') || url.startsWith('/')) {
    if (url.startsWith('/static/')) {
      // Treat links to statically-hosted content as external
      return true;
    }
    return false;
  }
  return true;
};

export { isExternalLink };
